import i18nSlice from "./i18n";
import userSlice from "./user";
import { combineReducers } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  i18n: i18nSlice.reducer,
  user: userSlice
});

export { rootReducer };
